import { useEffect } from 'react';
import useGetGuestJobs from '../../../hooks/useGetGuestJobs';
import { extractTextFromHTML, truncateText } from '../../../utils/utils';

interface Job {
  id: string;
  title: string;
  jobDescription?: string;
}

export const RecenltyAddedJobData = () => {
  const { getGuestJobs, jobs } = useGetGuestJobs() as {
    getGuestJobs: () => void;
    jobs: Job[];
  };

  useEffect(() => {
    getGuestJobs();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const guestJobsData = jobs.map((job) => ({
    link: `https://dashboard.locumspace.co/view-only-jobs?jobId=`,
    title: job.title || 'General Medicine SHO Position in Lagos',
    description:
      truncateText(extractTextFromHTML(job.jobDescription), 16) ||
      'Join our General Medicine SHO Position in Lagos: Elevate Your Career, Impact Patient Care',
  }));

  const dummyData = [
    {
      link: '/',
      title: 'Phamarcy SHO Position in Lagos',
      description:
        'Join our General Medicine SHO Position in Lagos: Elevate Your Career, Impact Patient Care',
    },
    {
      link: '/',
      title: 'General Medicine SHO Position in Lagos',
      description:
        'Join our General Medicine SHO Position in Lagos: Elevate Your Career, Impact Patient Care',
    },
    {
      link: '/',
      title: 'Radiography SHO Position in Lagos',
      description:
        'Join our General Medicine SHO Position in Lagos: Elevate Your Career, Impact Patient Care',
    },
  ];

  return [...guestJobsData, ...dummyData];
};
